/**
 * Messages für Shop-Phase
 */

// Shop öffnet
export const SHOP_OPENS = [
  "Shop ist offen! Zeit, dein Geld zu verbrennen.",
  "Willkommen im Shop! Was darf's sein?",
  "Der Laden ist auf! Schnapp dir was Gutes.",
  "Shop-Time! Geld ausgeben macht glücklich. Oder arm.",
];

// Mein Zug im Shop
export const MY_TURN = [
  "Du bist dran. Kauf was Sinnvolles - ausnahmsweise.",
  "Dein Turn! Was willst du haben?",
  "Zeit zum Shoppen! Entscheid dich.",
  "Du kannst kaufen. Mach's nicht zu kompliziert.",
];

// Warten auf andere
export const WAITING = [
  "{name} shoppt. Hoffentlich kauft er Mist.",
  "{name} ist am Überlegen. Geduld.",
  "Warte auf {name}. Der braucht ewig.",
  "{name} im Shop. Du danach.",
];

// Joker gekauft
export const BOUGHT_JOKER = [
  "{jokerName} gekauft! {description}",
  "Neuer Joker: {jokerName}! Nice.",
  "{jokerName} ist jetzt deiner!",
];

// Siegel gekauft
export const BOUGHT_SEAL = [
  "{sealName}-Siegel! Ab in den Stash.",
  "Siegel gekauft: {sealName}!",
  "{sealName}-Siegel für dich!",
];

// Bundle gekauft (Siegel)
export const BOUGHT_BUNDLE = [
  "{count} Siegel für den Preis von... zu viel.",
  "Bundle-Time! {count} Siegel auf einen Schlag.",
  "{count}x Siegel aus dem Bundle!",
];

// Joker-Bundle gekauft
export const BOUGHT_JOKER_BUNDLE = [
  "{jokerName} aus dem Bundle! Gute Wahl.",
  "Bundle-Pick: {jokerName}! Nice.",
  "Einer von drei: {jokerName}!",
];

// Joker verkauft
export const SOLD_JOKER = [
  "Joker verkauft. {price} Münzen. Hoffentlich keine Reue.",
  "{jokerName} weg, {price} Münzen da.",
  "Tschüss {jokerName}! Hallo {price} Münzen.",
];

// Reroll
export const REROLLED = [
  "Reroll! Neues Glück, gleiches Pech.",
  "Die Würfel sind neu gefallen! Was gibt's?",
  "Reroll abgeschlossen. Besser?",
  "Neues Angebot! Mal sehen...",
];

// Kein Geld
export const CANT_AFFORD = [
  "Zu arm. Vielleicht nächste Runde, Bettler.",
  "Nicht genug Münzen. Traurig.",
  "Das kannst du dir nicht leisten!",
  "Dein Geldbeutel sagt nein.",
];

// Zu viele Joker
export const JOKER_LIMIT = [
  "Joker-Limit erreicht! Verkauf erst einen.",
  "Kein Platz mehr für Joker. Limit ist Limit.",
  "Zu viele Joker! Mach Platz.",
];

// Fertig im Shop
export const DONE = [
  "Shopping erledigt. Warte auf die Schnarchnasen.",
  "Du bist fertig. Andere noch nicht.",
  "Ready! Lehn dich zurück.",
];

// Anderer hat gekauft
export const OTHER_BOUGHT = [
  "{name} kauft {item}. Interessant...",
  "{name} shoppt: {item}.",
  "Cha-ching! {name} holt sich {item}.",
];

// Timer-Warnung
export const TIMER_WARNING = [
  "Beeil dich! Nur noch {seconds} Sekunden!",
  "{seconds} Sekunden! Schneller shoppen!",
  "Timer läuft ab! {seconds}s!",
];

// Shop schließt
export const SHOP_CLOSING = [
  "Shop schließt! Letzte Chance!",
  "Zeit ist um! Shop macht zu.",
  "Ladenschluss! Weiter geht's.",
];
